export const TOASTS = {
  // Нозологии
  NOSOLOGY_DELETE_SUCCESS: 'Нозология удалена',
  NOSOLOGY_DELETE_ERROR: 'Не удалось удалить нозологию. Попробуйте ещё раз или обратитесь в поддержку.',
  NOSOLOGY_UPDATE_SUCCESS: 'Данные обновлены',
  NOSOLOGY_UPDATE_ERROR: 'Не удалось сохранить изменения. Попробуйте ещё раз или обратитесь в поддержку.',
  NOSOLOGY_CREATE_SUCCESS: 'Нозология добавлена',
  NOSOLOGY_CREATE_ERROR: 'Не удалось добавить нозологию. Попробуйте ещё раз или обратитесь в поддержку.',

  // Шаблоны задач КЗС
  KZS_TEMPLATE_DELETE_SUCCESS: 'Шаблон удален',
  KZS_TEMPLATE_DELETE_ERROR: 'Не удалось удалить шаблон. Попробуйте ещё раз или обратитесь в поддержку.',
  KZS_TEMPLATE_UPDATE_SUCCESS: 'Данные обновлены',
  KZS_TEMPLATE_UPDATE_ERROR: 'Не удалось сохранить изменения. Попробуйте ещё раз или обратитесь в поддержку.',
  KZS_TEMPLATE_CREATE_SUCCESS: 'Шаблон добавлен',
  KZS_TEMPLATE_CREATE_ERROR: 'Не удалось добавить шаблон. Попробуйте ещё раз или обратитесь в поддержку.',

  // Задачи КЗС
  KZS_TASK_DELETE_SUCCESS: 'Клинически-значимое событие удалено',
  KZS_TASK_DELETE_ERROR: 'Не удалось удалить клинически-значимое событие. Попробуйте ещё раз или обратитесь в поддержку.',
  KZS_TASK_UPDATE_SUCCESS: 'Данные обновлены',
  KZS_TASK_UPDATE_ERROR: 'Не удалось сохранить изменения. Попробуйте ещё раз или обратитесь в поддержку.',
  KZS_TASK_CREATE_SUCCESS: 'Клинически значимое событие добавлено',
  KZS_TASK_CREATE_ERROR: 'Не удалось добавить клинически значимое событие. Попробуйте ещё раз или обратитесь в поддержку.',
}
